const languageString = {
    en: 'English',
    fr: 'Français',
    nl: 'Nederlands',
    de: 'Deutsch',
};
export const getLanguageString = (locale) => languageString[locale];
